import { Component, Inject, OnInit } from "@angular/core";
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";

export interface LoadingModalData {
  message: string;
  detail?: string;
  progress?: number;
  showProgress?: boolean;
}

@Component({
  selector: "app-loading-modal",
  templateUrl: "./loading-modal.component.html",
  styleUrls: ["./loading-modal.component.scss"],
})
export class LoadingModalComponent implements OnInit {
  message: string = "Loading...";
  detail: string = "";
  progress: number = 0;
  showProgress: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<LoadingModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: LoadingModalData
  ) {
    if (data) {
      this.message = data.message || "Loading...";
      this.detail = data.detail || "";
      this.progress = data.progress || 0;
      this.showProgress = data.showProgress || false;
    }
  }

  ngOnInit(): void {
    // Update progress if provided
    if (this.data && this.data.progress !== undefined) {
      this.progress = this.data.progress;
    }
  }

  updateProgress(progress: number) {
    this.progress = progress;
  }

  updateMessage(message: string) {
    this.message = message;
  }

  updateDetail(detail: string) {
    this.detail = detail;
  }
}

